module.exports = __webpack_public_path__ + "img/building-bank.aa2a96fd.png";